'use client';

import React__default, { memo } from 'react';

var Circle = function (_a) {
    var _b = _a.color, color = _b === void 0 ? '#000' : _b, className = _a.className;
    return (React__default.createElement("svg", { className: className, width: 10, height: 11, viewBox: '0 0 10 11', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        React__default.createElement("rect", { y: '.5', width: 10, height: 10, rx: 5, fill: color })));
};
var Circle$1 = memo(Circle);

export { Circle$1 as default };
//# sourceMappingURL=Circle.js.map
